/**
 * HDE is currently unavailable in AU until launch.
 */
export const isHDEUnavailableInCountry = (countryCode: string): boolean => {
    return countryCode.toUpperCase() === 'AU';
};
